import React, { useState, useEffect } from "react";
import ModifyRolePermissionsPage from "../../../../entities/DashboardPage/HRModule/ModifyRolesPermissions";
import { useLocation, useNavigate } from "react-router-dom";
import AuthService from "../../../../api/AuthService";
import { useAlert } from "../../../../context/AlertContext";

const modifyRolePermission = () => {
  const [loading, setLoading] = useState(false);
  const [departmentData, setDepartmentData] = useState([]);

  const { state } = useLocation();
  const { item } = state || {};
  const id = item?._id;
  const {showAlert} = useAlert();
  const navigate = useNavigate();
  const permissionObj = localStorage.getItem("permission");
  const role = localStorage.getItem("role");
  const permission = JSON.parse(permissionObj);

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const result = await AuthService.getDepartment();
        if (result?.success) {
          setDepartmentData(result?.data?.position || []);
        }
      } catch (error) {
        // silently fail
      }
    };
    fetchDepartments();
  }, []);

  const handlePermission = async (data) => {
    setLoading(true);
    try {
      const result = await AuthService.handlePermission(data, id, item?.personalInfo?.permission);
      if (result?.success) { 
        showAlert(result?.message,"success")
        setLoading(false);
        navigate("/dashboard/rolesAndPermissions")
      } else {
        showAlert(result?.message,"success")
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <>
      <ModifyRolePermissionsPage disablePermission={permission} role={role} permission={item?.personalInfo?.permission} handleSubmit={handlePermission} loading={loading} departmentData={departmentData} />
    </>
  )

}

export default modifyRolePermission;
